import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftCouponThemeDataAtomFamily,
  giftCouponThemeListDataAtom,
  giftCouponThemeListStatusAtom,
  giftCouponThemeStatusAtomFamily,
} from './giftCouponTheme.atom';

// GiftCouponTheme 목록 조회 (admin)
const giftCouponThemeListUrl = (role: LowerRole) => {
  return `/${role}/gift-coupon-theme?${queryString({
    populate: { path: 'image' },
    options: { sort: { order: 1, name: 1 } },
  })}`;
};

export const useGiftCouponThemeListHook = (role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftCouponThemeListStatusAtom,
    giftCouponThemeListDataAtom,
    giftCouponThemeListUrl(role),
    fetcher,
    skip,
  );
};

// GiftCouponTheme 단건 조회
const giftCouponThemeUrl = (id: string, role: LowerRole) => {
  return `/${role}/gift-coupon-theme/${id}?${queryString({
    populate: { path: 'image' },
  })}`;
};

export const useGiftCouponThemeHook = (id: string, role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftCouponThemeStatusAtomFamily(id),
    giftCouponThemeDataAtomFamily(id),
    giftCouponThemeUrl(id, role),
    fetcher,
    skip || !id,
  );
};
